"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STRATEGY_VALUES_SHORT_LIST = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_STRATEGY_VALUES_SHORT_LIST = (0, gql_1.gql)(`
   query StrategyValuesShortList(
    $productTreeNodeId: ID!,
    $sort: [ProductTreeNodeUniqueLabelValueViewOrderBy!],
    $label: String!,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
    $filter: ProductTreeNodeUniqueLabelValueViewListFilter,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      labelValidation(filter: { some: { label: { equals: $label } } }) {
        edges {
          node {
            values(sort: $sort, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
              edges {
                node {
                  value
                }
              }
              pageInfo {
                hasNextPage
                endCursor
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
